export default (function (_ref) {
  var Vue = _ref.Vue;
  /**
   * Adds target="_blank" attribute on "a" element.
   */
  Vue.directive('open-links-in-new-tab', function (el) {
    el.querySelectorAll('a').forEach(function (item) {
      item.setAttribute('target', '_blank');
    });
  });
});

// /**
//  * Create comment node
//  *
//  * @private
//  * @author https://stackoverflow.com/questions/43003976/a-custom-directive-similar-to-v-if-in-vuejs#43543814
//  */
// function commentNode (el, vnode) {
//   const comment = document.createComment(' ')

//   Object.defineProperty(comment, 'setAttribute', {
//     value: () => undefined
//   })

//   vnode.text = ' '
//   vnode.elm = comment
//   vnode.isComment = true
//   vnode.context = undefined
//   vnode.tag = undefined
//   vnode.data.directives = undefined

//   if (vnode.componentInstance) {
//     vnode.componentInstance.$el = comment
//   }

//   if (el.parentNode) {
//     el.parentNode.replaceChild(comment, el)
//   }
// }